export const es = {
    time_limit_access_exceeded_contact_responsible:
        'Se ha excedido el límite de tiempo para acceder a la página, por favor contacte al responsable para generar un nuevo enlace si es necesario',
    url_not_found: 'URL no encontrada',
    ensure_url_entered_is_correct_with_responsible:
        'Por favor, asegúrese de que la URL ingresada es correcta con el responsable',
    temporary_link_expired: 'Enlace temporal expirado',
};
